import React from "react";
import Graph from "react-graph-vis";

//import "./styles.css";
// need to import the vis network css in order to show tooltip
//import "./network.css";

export default class GraphChart extends React.Component {
  render(){

const options = {
  layout: {
    improvedLayout:true
  },
  physics:{
    enabled:true,
    solver: "barnesHut",
    barnesHut: {
      gravitationalConstant: -9000,
      centralGravity: 0.001,
      springLength: 200,
      springConstant: 0.02,
      damping: 0.9,
      avoidOverlap: 1
    }
  },
  nodes:{
    color:{
      border:"#eeeced",
      background:"#eeeced",
      highlight:{
        border:"#867a82",
        background:"#eeeced",
      },
    }
  },
  edges: {
    color: "#000000"
  },
  height: "600px",
  width:"100%",
  interaction:{
    navigationButtons: true,
    keyboard: true,
  }
};

// If you want to do something with call backs this is where you would do it
  const events = {
    select: function(event) {
    }
  };
  //console.log(this.props.data)

  return (
    <Graph
      graph={this.props.data}
      options={options}
      events={events}
      getNetwork={network => {
        //  if you want access to vis.js network api you can set the state in a parent component using this property
      }}
    />
  );
}
}
